import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

// Extender dayjs con los plugins necesarios
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

/**
 * Filtra movimientos por rango de fechas
 * @param {Array} movimientos - Array de movimientos a filtrar
 * @param {String|null} fechaDesde - Fecha de inicio (puede ser null)
 * @param {String|null} fechaHasta - Fecha de fin (puede ser null)
 * @returns {Array} Array de movimientos filtrados
 */
export function filterMovimientosByDate(movimientos, fechaDesde, fechaHasta) {
  const startDateRaw = fechaDesde ? dayjs(fechaDesde) : null;
  const endDateRaw = fechaHasta ? dayjs(fechaHasta) : null;
  
  // Si no hay filtros de fecha, retornar todos los movimientos
  if ((!startDateRaw || !startDateRaw.isValid()) && (!endDateRaw || !endDateRaw.isValid())) {
    return movimientos;
  }
  
  // Normalizar fechas: inicio del d�a para startDate, fin del d�a para endDate
  let startDate = null;
  let endDate = null;
  
  if (startDateRaw && startDateRaw.isValid()) {
    startDate = startDateRaw.startOf('day'); // 00:00:00.000
  }
  if (endDateRaw && endDateRaw.isValid()) {
    endDate = endDateRaw.endOf('day'); // 23:59:59.999
  }
  
  if (startDate && endDate) {
    return movimientos.filter(movimiento => {
      let date = dayjs(parseInt(movimiento.fecha));
      return date.isValid() && (date.isSameOrAfter(startDate, 'day') && date.isSameOrBefore(endDate, 'day'));
    });
  } else if (startDate) {
    return movimientos.filter(movimiento => {
      let date = dayjs(parseInt(movimiento.fecha));
      return date.isValid() && date.isSameOrAfter(startDate, 'day');
    });
  } else if (endDate) {
    return movimientos.filter(movimiento => {
      let date = dayjs(parseInt(movimiento.fecha));
      return date.isValid() && date.isSameOrBefore(endDate, 'day');
    });
  }
  return movimientos;
}

/**
 * Valida que las fechas sean correctas para un filtro
 * @param {String|null} fechaDesde - Fecha de inicio (puede ser null)
 * @param {String|null} fechaHasta - Fecha de fin (puede ser null)
 * @returns {Object} { isValid: boolean, error: string|null }
 */
export function validateDateRange(fechaDesde, fechaHasta) {
  const startDate = fechaDesde ? dayjs(fechaDesde) : null;
  const endDate = fechaHasta ? dayjs(fechaHasta) : null;
  
  // Si ambas fechas est�n presentes, validar que fechaDesde <= fechaHasta
  if (startDate && endDate) {
    if (!startDate.isValid() || !endDate.isValid()) {
      return { isValid: false, error: 'Una o ambas fechas son inv�lidas' };
    }
    if (startDate.isAfter(endDate)) {
      return { isValid: false, error: 'La fecha de inicio debe ser anterior o igual a la fecha de fin' };
    }
  } else if (startDate && !startDate.isValid()) {
    return { isValid: false, error: 'La fecha de inicio es inv�lida' };
  } else if (endDate && !endDate.isValid()) {
    return { isValid: false, error: 'La fecha de fin es inv�lida' };
  }
  
  return { isValid: true, error: null };
}

